import { createFileRoute } from "@tanstack/react-router";
import { PageHero } from "@/components/site/PageHero";

export const Route = createFileRoute("/privacy")({
  head: () => ({
    meta: [
      { title: "Privacy Policy — IZHUB Cleaning Service" },
      { name: "description", content: "How IZHUB Cleaning Service collects, uses and protects your personal information." },
      { property: "og:title", content: "Privacy Policy — IZHUB Cleaning Service" },
      { property: "og:description", content: "How IZHUB Cleaning Service collects, uses and protects your personal information." },
      { name: "robots", content: "noindex" },
      { property: "og:url", content: "https://izhubcleaning.uk/privacy" },
    ],
    links: [{ rel: "canonical", href: "https://izhubcleaning.uk/privacy" }],
  }),
  component: Privacy,
});

function Privacy() {
  return (
    <>
      <PageHero title="Privacy Policy" intro="How we handle your information — plain and simple." />
      <section className="pb-24">
        <article className="container-x text-surface max-w-3xl prose prose-neutral prose-headings:font-display space-y-6 text-foreground/90">
          <p className="text-sm text-muted-foreground">Last updated: {new Date().toLocaleDateString("en-GB", { month: "long", year: "numeric" })}</p>

          <h2 className="font-display text-2xl">Who we are</h2>
          <p>IZHUB Cleaning Service ("we", "us", "our") operates the website izhubcleaning.uk and provides cleaning services across the Salisbury Plain area. You can contact us at <a href="mailto:info@izhubcleaning.uk" className="text-primary underline">info@izhubcleaning.uk</a>.</p>

          <h2 className="font-display text-2xl">What we collect</h2>
          <p>We only collect information you provide to us — typically your name, email, phone number, postcode, property details and any notes about the clean you need. We may also collect basic technical information such as your IP address and browser type.</p>

          <h2 className="font-display text-2xl">How we use it</h2>
          <p>We use your information to respond to your enquiry, provide a quote, deliver the cleaning service, keep records for accounting, and follow up after a job. We do not sell your data.</p>

          <h2 className="font-display text-2xl">Legal basis</h2>
          <p>We process personal data on the basis of your consent, our legitimate interests in running our business, and where necessary to perform a contract with you.</p>

          <h2 className="font-display text-2xl">Sharing</h2>
          <p>We do not share your data with third parties except where required to run the service (for example, email or payment providers) or where required by law.</p>

          <h2 className="font-display text-2xl">Your rights</h2>
          <p>Under UK GDPR you have the right to access, correct, delete or restrict processing of your personal data. Contact us at info@izhubcleaning.uk to exercise these rights.</p>

          <h2 className="font-display text-2xl">Cookies</h2>
          <p>Our website uses essential cookies to function correctly. We do not use tracking cookies without your consent.</p>

          <h2 className="font-display text-2xl">Changes</h2>
          <p>This policy may be updated from time to time. Any changes will be posted on this page.</p>
        </article>
      </section>
    </>
  );
}
